import { Chip } from '@archer-technologies/ui-components';
import { GroupingPanel } from '@devexpress/dx-react-grid-material-ui';
import * as React from 'react';

const GroupingPanelEmptyMessageComponent = (props: GroupingPanel.EmptyMessageProps) => (
  <GroupingPanel.EmptyMessage {...props} className="grouping-panel-empty-message" />
);

const GroupingPanelItemComponent = ({
  item: {
    column: { title }
  },
  onGroup
}: GroupingPanel.ItemProps) => {
  return <Chip label={title as string} onDelete={onGroup} onClick={onGroup} clickable id={`grouped-item-chip-id-${title}`} />;
};

export { GroupingPanelEmptyMessageComponent, GroupingPanelItemComponent };
